<form [formGroup]="form" (submit)="onSubmit($event)">
  <div class="modal-body">
    <div class="form-group">
      <p id="passwordHelpBlock" class="form-text text-muted">
        Invite a new user to this account:
      </p>

      <label for="invitee-email" class="form-control-label sr-only">
        Account ID
      </label>
      <input
        name="invitee-email"
        type="text"
        class="form-control"
        placeholder="invitee email"
        [formControl]="inviteeEmail"
      />
      <div
        *ngIf="
          state === formStates.submitting ||
          (inviteeEmail.invalid && (inviteeEmail.dirty || inviteeEmail.touched))
        "
        class="form-control-feedback"
      >
        <div *ngIf="inviteeEmail.hasError('required')">
          User email is required.
        </div>

        <div *ngIf="inviteeEmail.hasError('pattern')">
          User email is invalid
        </div>
      </div>
    </div>
    <div *ngIf="state === formStates.failure" class="alert alert-danger">
      {{ errorMessage }}
    </div>
  </div>

  <div class="modal-footer">
    <ng-content></ng-content>
    <button
      type="button"
      type="submit"
      class="btn btn-success"
      [disabled]="state === formStates.submitting || inviteeEmail.invalid"
    >
      <i class="fas fa-check"></i> <span>Invite</span>
    </button>
  </div>
</form>
<div *ngIf="state === formStates.submitting" class="loading-spinner">
  <app-loading-spinner></app-loading-spinner>
</div>
